// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as BsCss from "../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "@rescript/std/lib/es6/js_math.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as PaginationButton from "./PaginationButton.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: /* [] */0
    });

var button = Curry._1(BsCss.style, {
      hd: BsCss.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BsCss.display("flex"),
        tl: {
          hd: BsCss.justifyContent("center"),
          tl: {
            hd: BsCss.maxWidth(BsCss.rem(4.75)),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  container: container,
  button: button
};

function makePagearray(currentPage, totalCount) {
  if (currentPage <= 3) {
    return [
            1,
            2,
            3,
            0,
            totalCount
          ];
  } else if (currentPage >= (totalCount - 2 | 0)) {
    return [
            1,
            0,
            totalCount - 2 | 0,
            totalCount - 1 | 0,
            totalCount
          ];
  } else {
    return [
            1,
            0,
            currentPage,
            0,
            totalCount
          ];
  }
}

var make = React.memo(function (props) {
      var urlConstructor = props.urlConstructor;
      var currentPage = props.currentPage;
      var totalPages = Js_math.ceil(props.count / props.pageSize);
      var tmp;
      if (totalPages <= 5) {
        tmp = Belt_Array.makeBy(totalPages, (function (i) {
                var pageStr = String(i + 1 | 0);
                return JsxRuntime.jsx(PaginationButton.make, {
                            title: pageStr,
                            href: Curry._1(urlConstructor, i + 1 | 0),
                            selected: currentPage === (i + 1 | 0)
                          }, "page_" + pageStr);
              }));
      } else {
        var pages = makePagearray(currentPage, totalPages);
        tmp = Belt_Array.mapWithIndex(pages, (function (idx, page) {
                return JsxRuntime.jsx(PaginationButton.make, {
                            title: page === 0 ? "..." : String(page),
                            href: Curry._1(urlConstructor, page),
                            disabled: page === 0,
                            selected: currentPage === page
                          }, "page_" + String(idx));
              }));
      }
      return JsxRuntime.jsx("nav", {
                  children: JsxRuntime.jsxs("ul", {
                        children: [
                          JsxRuntime.jsx(PaginationButton.make, {
                                title: "Back",
                                href: Curry._1(urlConstructor, currentPage - 1 | 0),
                                disabled: (currentPage - 1 | 0) < 1,
                                className: button,
                                isFirst: true,
                                large: true
                              }),
                          tmp,
                          JsxRuntime.jsx(PaginationButton.make, {
                                title: "Next",
                                href: Curry._1(urlConstructor, currentPage + 1 | 0),
                                disabled: currentPage >= totalPages,
                                className: button,
                                isLast: true,
                                large: true
                              })
                        ],
                        className: Cn.make([
                              Belt_Option.getWithDefault(props.className, ""),
                              container
                            ])
                      }),
                  "aria-label": "Pagination navigation",
                  role: "navigation"
                });
    });

export {
  Styles ,
  makePagearray ,
  make ,
}
/* container Not a pure module */
